/*
This file is located in the main branch
Last time the file was updated (UTC): [06.12.2023 15:23:18]
Permissions to update outside the main branch: [false]
*/

import { Controller, FieldValues, Path, PathValue, useFormContext } from 'react-hook-form';

const BaseReactHookFormValue = <TFieldValues extends FieldValues>({
    name,
    renderCallBack,
}: {
    name: Path<TFieldValues>;
    renderCallBack?: (value: PathValue<TFieldValues, Path<TFieldValues>>) => string | JSX.Element;
}) => {
    const { control } = useFormContext<TFieldValues>();

    return (
        <Controller<TFieldValues>
            name={name}
            control={control}
            render={({ field: { value } }) => <>{renderCallBack ? renderCallBack(value) : value}</>}
        />
    );
};

export default BaseReactHookFormValue;
